import { render, staticRenderFns } from "./TransferenciaStockDashBoardComponent.vue?vue&type=template&id=538dec99&"
import script from "./TransferenciaStockDashBoardComponent.vue?vue&type=script&lang=js&"
export * from "./TransferenciaStockDashBoardComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports